// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetScheduleByUserRequest,
  TGetScheduleByUserModel,
  IMappers,
  TGetScheduleByUserResponse,
  IGetScheduleByUserResponse,
  IGetScheduleByUserResponseError,
} from './types';

export const defaultConfig: TGetScheduleByUserModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'work-time',
  pathApi: '/v1/get-schedule-by-user/',
} as TGetScheduleByUserModel;

export function createGetScheduleByUserModel(parameters: IGetScheduleByUserRequest): TGetScheduleByUserModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetScheduleByUserOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetScheduleByUserRequest;
}

export async function fetchGetScheduleByUser<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetScheduleByUserOptions<TResponse200, TResponse400>): Promise<
  TGetScheduleByUserResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetScheduleByUserModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetScheduleByUserResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetScheduleByUserResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetScheduleByUserResponse;
}
